import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import { IoMdInformationCircleOutline } from "react-icons/io";
import "./tarimas_style.css";
import ReactDOMServer from "react-dom/server";
import "@github/relative-time-element";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import TableControls from "../../../../components/tableControler/tableControler";
import { Helmet } from "react-helmet";

function Tarimas({ handleMenuClick }) {
  const [pallets, setPallets] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);

  const filteredData = searchValue
    ? pallets.filter((pallets) =>
        pallets.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : pallets;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const getEntries = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/pallets`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.error === false && res.data.status === 200) {
        setPallets(res.data.body.pallets);
        setLoading(false);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        setLoading(false);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      setLoading(false);
    }
  };

  const deletePallet = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });
      if (result.isConfirmed) {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/pallets/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        Swal.fire("¡Eliminado!", "La tarima ha sido eliminada.", "success");
        setUpdateTrigger(!updateTrigger);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const updatePallet = async (id) => {
    try {
      // Obtener los datos de la tarima a editar del servidor
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/pallets/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      const palletData = response.data.body.pallet[0];
      const result = await Swal.fire({
        title: "Editar tarima",
        html:
          `<div class="form-grid">` +
          `<input type="text" id="name" class="swal2-input" placeholder="Nombre" value="${palletData.name}">` +
          `<input type="text" id="length" class="swal2-input" placeholder="Largo" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" value="${palletData.length}">` +
          `<input type="text" id="height" class="swal2-input" placeholder="Alto" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" value="${palletData.height}">` +
          `<input type="text" id="width" class="swal2-input" placeholder="Ancho" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" value="${palletData.width}">` +
          `<input type="text" id="weight" class="swal2-input" placeholder="Peso" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" value="${palletData.weight}">` +
          `</div>`,
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        preConfirm: async () => {
          const name = document.getElementById("name").value;
          const length = document.getElementById("length").value;
          const height = document.getElementById("height").value;
          const width = document.getElementById("width").value;
          const weight = document.getElementById("weight").value;

          if (!name || !length || !height || !width || !weight) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return false;
          }

          return {
            name,
            length,
            height,
            width,
            weight,
          };
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

      if (result.isConfirmed) {
        const updatedUserData = result.value;
        // Realizar la solicitud PUT al servidor para actualizar la tarima
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/pallets/update/${id}`,
          updatedUserData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire(
          "¡Actualizado!",
          "La tarima ha sido actualizada exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const createPallet = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear tarima",
        html:
          '<div class="form-grid">' +
          '<input type="text" id="name" class="swal2-input" placeholder="Nombre">' +
          '<input type="text" id="length" class="swal2-input" placeholder="Largo" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\')">' +
          '<input type="text" id="height" class="swal2-input" placeholder="Alto" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\')">' +
          '<input type="text" id="width" class="swal2-input" placeholder="Ancho" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\')">' +
          '<input type="text" id="weight" class="swal2-input" placeholder="Peso" inputmode="decimal" oninput="this.value = this.value.replace(/[^0-9.]/g, \'\')">' +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: async() =>{
          const name = document.getElementById("name").value;
          const length = document.getElementById("length").value;
          const height = document.getElementById("height").value;
          const width = document.getElementById("width").value;
          const weight = document.getElementById("weight").value;

          if (!name || !length || !height || !width || !weight) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return false;
          }

          return {
            name,
            length,
            height,
            width,
            weight,
          };
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

      if (result.isConfirmed) {
        const userData = result.value;

        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/pallets/create`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        Swal.fire(
          "¡Creado!",
          "La tarima ha sido creada exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Acción cancelada.", "error");
      }
    } catch (error) {
      if (error.response.data.message === "la tarima ya existe") {
        Swal.fire("Error al crear la tarima", "La tarima ya existe.", "error");
      } else if (
        error.response.data.message === "la tarima fue eliminada anteriormente"
      ) {
        Swal.fire(
          "Error al crear la tarima",
          "La tarima fue eliminada anteriormente",
          "error"
        );
      } else if (
        error.response.data.errors[0] ===
        "La contraseña debe ser mayor a 6 caracteres"
      ) {
        Swal.fire(
          "Error al crear la tarima",
          "La contraseña debe ser mayor a 6 caracteres",
          "error"
        );
      } else if (
        error.response.data.errors[0] === "El formato del correo no es valido"
      ) {
        Swal.fire(
          "Error al crear la tarima",
          "El formato del correo no es válido",
          "error"
        );
      } else {
        Swal.fire(
          "Error al crear la tarima",
          "No se ha creado ninguna tarima."
        );
      }
    }
  };

  const showPallet = async (id) => {
    try {
      // Realizar la solicitud POST para obtener los datos del pallet
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/pallets/${id}`
      );
      const palletData = response.data.body.pallet[0]; // Obtener los datos del primer pallet en la respuesta

      await Swal.fire({
        title: "Ver tarima",
        html: `<div class="form-grid" style="line-height: 1.6em; text-align: left;">
                    <div><strong>Nombre:</strong> ${palletData.name}</div>
                    <div><strong>Largo:</strong> ${palletData.length}</div>
                    <div><strong>Alto:</strong> ${palletData.height}</div>
                    <div><strong>Ancho:</strong> ${palletData.width}</div>
                    <div><strong>Peso:</strong> ${palletData.weight}</div>
                </div>`,
      });

      // No es necesario manejar resultado ya que no hay botones para confirmar o cancelar
    } catch (error) {
      // Manejar errores aquí
    }
  };

  const handleSearch = (value) => {
    setSearchValue(value.trim());
  };

  const resetSearch = async () => {
    setSearchValue("");
    await getEntries();
  };

  useEffect(() => {
    getEntries();
  }, [updateTrigger]);

  return (
    <>
      <Helmet>
        <title>Horus | Tarimas</title>
      </Helmet>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer container-fluid"
          id="datatables_wrapper"
        >
          <div className="text-right mb-4 ">
            <button className="btnn" onClick={createPallet}>
              Añadir Tarimas
            </button>
          </div>
          <TableControls
            onSearch={handleSearch}
            onEntriesChange={showEntries}
            liveSearch={true}
            debounceTime={500}
          />

          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Nombre
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "81.2031px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((pallet) => (
                    <tr key={pallet.id}>
                      <td>{pallet.name}</td>
                      <td>
                        <IoMdInformationCircleOutline
                          className="showButton"
                          onClick={() => {
                            showPallet(pallet.id);
                          }}
                        />
                        <FaEdit
                          className="editButton"
                          onClick={() => {
                            updatePallet(pallet.id);
                          }}
                        />
                        <FaTimes
                          className="deleteButton"
                          onClick={() => {
                            deletePallet(pallet.id);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default Tarimas;
